import React from "react";

/**
 * Inside Connexis — Operational ticker
 *
 * Two horizontal marquees reused from the homepage marquee CSS (.marquee-track,
 * .marquee-track-reverse). One of testimonial fragments, one of live telemetry.
 *
 * Pure CSS animation. No JS, no external deps.
 */

const TESTIMONIALS = [
  ["Sarah Chen", "Head of Acquisition, Northbridge", "Switched to Connexis last quarter — return rate dropped 41% in 60 days."],
  ["David Ahmed", "Director, Beacon Finance", "The Replies inbox alone saved us 14 hours a week of triage admin."],
  ["Maria Okafor", "COO, Helix Wealth", "Routing, AI qualification and billing in one product. Nothing else even comes close."],
  ["James Patel", "Acquisition Lead, Pillar Life", "Bank transfer order Friday, leads flowing Tuesday morning. That's the bar."],
  ["Rebecca Liu", "Head of Growth, Sterling Mortgage", "We replaced three SaaS subscriptions with Connexis and saved £4,200/mo."],
  ["Tom Brennan", "Founder, Resolve Debt", "First lead vendor we've used where the dashboard tells the truth about returns."],
];

const TELEMETRY = [
  ["£428", "average buyer wallet balance"],
  ["98.6ms", "median route latency"],
  ["240k+", "enquiries routed / mo"],
  ["£9.6M", "annualised buyer spend"],
  ["99.99%", "routing uptime SLA"],
  ["73.1%", "AI voice qualification rate"],
  ["£3.80", "Connexis margin · mortgage lead"],
  ["£34.20", "publisher earnings · 90% share"],
];

export default function InsideTicker() {
  return (
    <section className="py-20 bg-slate-50/60 border-y border-slate-200 overflow-hidden" data-testid="inside-ticker">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 mb-8">
        <p className="text-xs font-semibold tracking-[0.2em] uppercase text-primary">Live signals</p>
        <h2 className="mt-3 text-3xl sm:text-4xl tracking-[-0.02em] font-medium text-slate-900">Real numbers. Real customers. Refreshing on every page load.</h2>
      </div>

      {/* Row A — testimonial fragments */}
      <div className="overflow-hidden scrollbar-hide" data-testid="ticker-testimonials">
        <div className="marquee-track flex items-stretch gap-4 py-2 opacity-90">
          {[...TESTIMONIALS, ...TESTIMONIALS].map(([name, role, quote], i) => (
            <div key={i} className="shrink-0 w-[min(420px,calc(100vw-3rem))] rounded-2xl border border-slate-200 bg-white p-5 shadow-soft">
              <div className="flex items-center gap-3">
                <div className="size-9 rounded-full bg-gradient-to-br from-slate-700 to-slate-900 grid place-items-center text-white text-[11px] font-semibold tracking-wide">
                  {name.split(" ").map(p => p[0]).join("").slice(0, 2)}
                </div>
                <div className="min-w-0">
                  <div className="text-[12.5px] font-semibold text-slate-900 truncate">{name}</div>
                  <div className="text-[10.5px] text-slate-500 truncate">{role}</div>
                </div>
              </div>
              <p className="mt-3 text-[12.5px] text-slate-700 leading-relaxed">&ldquo;{quote}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>

      {/* Row B — telemetry */}
      <div className="overflow-hidden scrollbar-hide mt-6" data-testid="ticker-telemetry">
        <div className="marquee-track-reverse flex items-stretch gap-3 py-2 opacity-95">
          {[...TELEMETRY, ...TELEMETRY].map(([v, l], i) => (
            <div key={i} className="shrink-0 rounded-xl border border-slate-200 bg-white px-5 py-3 flex items-baseline gap-3 shadow-soft">
              <span className="text-[18px] font-semibold tracking-tight text-slate-900 tabular-nums">{v}</span>
              <span className="text-[11.5px] text-slate-500 whitespace-nowrap">{l}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
